<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_contact_extension') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="socialMediaForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="siteid">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" id="createdBy">{{siteid.text}}</span>
                                    <!--<v-select v-model="siteid"
                                              @change="changedValue"
                                              @input="changedValueSite()"
                                              name="siteid"
                                              id="siteid"
                                              label="text"
                                              :clearable="false"
                                              :filterable="false"
                                              :options="sitesArr"
                                              @search="onSearchSite"
                                              placeholder="Select Location">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{siteidError}}</font>-->
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="deptid">Department :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" id="createdBy">{{deptid.text}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="companyName">Company :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" >{{companyName}}</span>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" >Contact</div>
                                </div>
                            </div>
                            <div v-if="contacts.length < plusCount" class="col-12 forms-block">
                                <div class="col-1 paddingleft0">
                                    <button type="button" v-on:click="addNewContactInputs" class="btn btn-block btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="mt-2 col-11 paddingleft0">
                                    Would you like add more Contacts?
                                </div>
                            </div>
                            <div class="row col-12" v-for="(contactGroup, index) in contacts">
                                <div class="col-12 forms-block">
                                    <div class="col-1 paddingleft0">
                                        <button type="button" v-on:click="removeContact(index)" class="btn btn-block btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-11 paddingleft0">
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label" >Contact Label :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="contactGroup.contact_label" type="text"
                                                       name="contacts[][contact_label]" class="form-control" placeholder="Contact Label">
                                            </div>
                                        </div>
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label">Contact :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="contactGroup.contact" type="text"
                                                       name="contacts[][contact]" class="form-control" placeholder="Contact"  maxlength="190">
                                                <div class="requiredstar">*</div>
                                                <font class="text-danger" :id="'contact_'+index"></font>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Address Line-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="addressLine">Address Line :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="addressLine" class="form-control" id="addressLine" placeholder="Address Line"></textarea>
                                </div>
                            </div>
                            <!--Note-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="note">Contact Note :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="note" class="form-control" id="note" placeholder="Contact Note"></textarea>
                                </div>
                            </div>
                            <!--Created BY-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" >{{createdByTitle}} :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" id="createdBy">{{createdBy}}</span>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addContactBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addContact()">
                                    <input id="addAndContinueContactBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addContact(flag='Save and Continue')">
                                    <input id="CancelContactBtn" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import EventBus from '../../event-bus';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'AddContact',
        pageTitle: 'Add Department Contact',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                editSiteID: 0,
                editDeptID: 0,
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                createdByTitle: '',
                createdBy: '',
                pageTitle: '',
                addressLine: '',
                note: '',
                deptid: '',
                siteid: '',
                sitesArr: [],
                companyName: '',
                contactPerson: '',
                userId: '',
                userIdError: '',
                contact: {
                    contact_label: '',
                    contact: '',
                },
                contacts: [{
                        contact_label: '',
                        contact: '',
                    }
                ],
                //Errors
                contactError: '',
                siteidError: '',
                plusCount: 20
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
            } else {
                self.$router.push("/login");
            }
            if (segments[2] == 'updatedepartmentcontact') {
                if (segments[3]) {
                    var res = segments[3].split("_");
                    self.editSiteID = res[0];
                    self.editDeptID = res[1];
                    self.createdByTitle = 'Update By';
                    self.pageTitle = 'Edit Department Contact';
                    self.loadContact();
                    $("#addAndContinueContactBtn").hide();
                    $("#addContactBtn").val("Update");
                }
            } else {
                self.createdByTitle = 'Created By';
                self.pageTitle = 'Add Department Contact';
                self.createdBy = userJson.first_name + " " + userJson.last_name;
            }
            $("#contact").on('keyup', function () {
                self.contactError = '';
            });
            $("#siteid").on('keyup', function () {
                self.siteidError = '';
            });
            $("#alertError").hide();
            self.getPermissions();
        },
        watch: {
            siteid: function (siteid) {
                let self = this;
                self.companyName = "";
                if (siteid != null) {
                    $.each(self.sitesArr, function (i) {
                        if (siteid.value == self.sitesArr[i].value) {
                            self.companyName = self.sitesArr[i].company;
                        }
                    });
                }
            },
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/departmentextensionlist');
            },
            addNewContactInputs: function () {
                if (self.contacts.length < self.plusCount) {
                    self.contacts.push(Vue.util.extend({}, self.contact))
                }
            },
            removeContact: function (index) {
                Vue.delete(self.contacts, index);
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueSite: function () {
                self.siteidError = "";
            },
            changedValueUser: function () {
            },
            onSearchSite(search, loading) {
                if (search.length > 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadSite(loading, search, this);
                }
            },
            checkForm: function () {
                var checked = true;
                self.siteidError = "";
                if (!self.siteid) {
                    self.siteidError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                $.each(self.contacts, function (i) {
                    $("#contact_" + i).html('');
                    if (self.contacts[i].contact == "") {
                        $("#contact_" + i).html("Contact Required");
                        if (checked) {
                            checked = false;
                        }
                    }/* else if (!self.checkContact(self.contacts[i].contact)) {
                     $("#contact_" + i).html('Please Enter Valid Contact Number');
                     if (checked) {
                     checked = false;
                     }
                     }*/
                });
                return checked;
            },
            checkContact: function (contact) {
                var re = /^(?=.*[0-9])[- +()0-9]+$/;
                return re.test(contact);
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            loadContact() {
                var userJson = [];
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    userJson = JSON.parse(userObj);
                } else {
                    self.$router.push("/login");
                }
                var path = window.location.pathname;
                var segments = path.split("/");
                var res = segments[3].split("_");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        site_id: res[0],
                        dept_id: res[1],
                    }
                };
                HTTP.get("loaddepartmentcontact", config)
                        .then(function (response) {
                            self.editSiteID = response.data.content.site_id;
                            self.editDeptID = response.data.content.department_id;
                            self.siteid = {'text': response.data.content.site_name, 'value': response.data.content.site_id};
                            self.deptid = {'text': response.data.content.dept_name, 'value': response.data.content.department_id};
                            self.companyName = "";
                            setTimeout(function () {
                                self.companyName = response.data.content.company;
                                self.contacts = (response.data.content.contacts != '') ? JSON.parse(response.data.content.contacts) : self.contacts;
                                self.createdBy = userJson.first_name + " " + userJson.last_name;
                            }, 300);
                            self.addressLine = response.data.content.address_line;
                            self.note = response.data.content.note;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            addContact(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    if (segments[2] == 'updatedepartmentcontact') {
                        if (self.editSiteID && self.editDeptID) {
                            var data = {
                                location: self.siteid.value,
                                contact: self.contacts,
                                site_id: self.editSiteID,
                                dept_id: self.editDeptID,
                                address_line: self.addressLine,
                                note: self.note
                            };
                            $("#addContactBtn").val("Updating ...");
                            $("#addContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueContactBtn").val("Saving ...");
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#addContactBtn").prop("disabled", true);
                                $("#CancelContactBtn").prop("disabled", true);
                            } else {
                                $("#addContactBtn").val("Saving ...");
                                $("#addContactBtn").prop("disabled", true);
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#CancelContactBtn").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            location: self.siteid.value,
                            contact: self.contacts,
                            address_line: self.addressLine,
                            note: self.note
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueContactBtn").val("Saving ...");
                            $("#addAndContinueContactBtn").prop("disabled", true);
                            $("#addContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        } else {
                            $("#addContactBtn").val("Saving ...");
                            $("#addContactBtn").prop("disabled", true);
                            $("#addAndContinueContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        }
                    }
                    HTTP.post("addupdatedepartmentcontact", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updatedepartmentcontact') {
                                    if (self.editSiteID && self.editDeptID) {
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        $(".alert-success").addClass("show");
                                        /*self.siteid = '';*/
                                        self.contacts = [{contact_label: '', contact: '', }];
                                        self.createdBy = userJson.first_name + " " + userJson.last_name;
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatedepartmentcontact') {
                                    if (self.editSiteID && self.editDeptID) {
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            /*self.siteid = '';*/
                                            self.contacts = [{contact_label: '', contact: '', }];
                                            self.createdBy = userJson.first_name + " " + userJson.last_name;
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", true);
                                            $("#CancelContactBtn").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        /*self.siteid = '';*/
                                        self.contacts = [{contact_label: '', contact: '', }];
                                        self.createdBy = userJson.first_name + " " + userJson.last_name;
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", true);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                            });
                }
            },
            loadSite(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        get_all: 1
                    }
                };
                HTTP.get("getsite", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            $.each(response.data.content, function (i) {
                                /*if (i == 0) {
                                 self.siteid = response.data.content[i];
                                 }*/
                                self.sitesArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/EditDepartmentContact.vue